<template>
  <div class="pdf-all">
    <div class="flex just-end mb20">
      <el-button class="ml10 down-btn" type="primary" @click="downPdf">
        群体报告下载
      </el-button>
    </div>
    <div v-if="page1Show" class="report-pdf">
      <div class="flex just-c mb20">
        <div id="Page1Pdf1">
          <Page1Pdf1 :search-params="searchParams1" />
        </div>
      </div>
      <div class="flex just-c mb20">
        <div id="Page1Pdf2">
          <Page1Pdf2 :search-params="searchParams1" />
        </div>
      </div>
      <div class="flex just-c mb20">
        <div id="Page1Pdf3">
          <Page1Pdf3 :search-params="searchParams1" />
        </div>
      </div>
      <div class="flex just-c mb20">
        <div id="Page1Pdf4">
          <Page1Pdf4 :search-params="searchParams1" />
        </div>
      </div>
    </div>

    <div v-if="page2Show" class="report-pdf">
      <div v-if="searchParams2.groupBetweenCompareType === 101">
        <div class="flex just-c mb20">
          <div id="Page2Pdf1">
            <Page2Pdf1 :search-params="searchParams2" />
          </div>
        </div>
        <div class="flex just-c mb20">
          <div id="Page2Pdf2">
            <Page2Pdf2 :search-params="searchParams2" />
          </div>
        </div>
        <div class="flex just-c mb20">
          <div id="Page2Pdf3">
            <Page2Pdf3 :search-params="searchParams2" />
          </div>
        </div>
      </div>
      <div v-if="searchParams2.groupBetweenCompareType === 103">
        <div class="flex just-c mb20">
          <div>
            <Page2Pdf4 ref="Page2Pdf4" :search-params="searchParams2" />
          </div>
        </div>
        <div class="flex just-c ">
          <div>
            <Page2Pdf5 ref="Page2Pdf5" :search-params="searchParams2" />
          </div>
        </div>
        <!-- <div v-for="(v,index) in zones" :key="index" class="flex just-c ">
          <div>
            <Page2Pdf6 :ref="`Page2Pdf6${v}`" :type="v" :search-params="searchParams2" />
          </div>
        </div> -->
      </div>
    </div>

    <div v-if="page3Show" class="report-pdf">
      <div class="flex just-c mb20">
        <div id="Page3Pdf1">
          <Page3Pdf1 :search-params="searchParams3" />
        </div>
      </div>
      <div class="flex just-c mb20">
        <div id="Page3Pdf2">
          <Page3Pdf2 :search-params="searchParams3" />
        </div>
      </div>
      <div class="flex just-c mb20">
        <div id="Page3Pdf3">
          <Page3Pdf3 :search-params="searchParams3" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Page1Pdf1 from './_components/Page1Pdf1'
import Page1Pdf2 from './_components/Page1Pdf2'
import Page1Pdf3 from './_components/Page1Pdf3'
import Page1Pdf4 from './_components/Page1Pdf4'

import Page2Pdf1 from './_components/Page2Pdf1'
import Page2Pdf2 from './_components/Page2Pdf2'
import Page2Pdf3 from './_components/Page2Pdf3'
import Page2Pdf4 from './_components/Page2Pdf4'
import Page2Pdf5 from './_components/Page2Pdf5'
// import Page2Pdf6 from './_components/Page2Pdf6'

import Page3Pdf1 from './_components/Page3Pdf1'
import Page3Pdf2 from './_components/Page3Pdf2'
import Page3Pdf3 from './_components/Page3Pdf3'
import { savePdfImgs } from '@/utils/savePdf.js'

export default {
  components: {
    Page1Pdf1,
    Page1Pdf2,
    Page1Pdf3,
    Page1Pdf4,
    Page2Pdf1,
    Page2Pdf2,
    Page2Pdf3,
    Page2Pdf4,
    Page2Pdf5,
    // Page2Pdf6,
    Page3Pdf1,
    Page3Pdf2,
    Page3Pdf3
  },
  props: {
    searchParams: {}
  },
  data() {
    return {
      page1Show: false,
      page2Show: false,
      page3Show: false,
      searchParams1: {

      },
      searchParams2: {

      },
      searchParams3: {

      },
      zones: [
        103, 104, 105
      ]
    }
  },
  created() {
    for (let i = 0; i < 3; i++) {
      if (localStorage.getItem(`page${i + 1}Show`) === 'true') {
        this[`page${i + 1}Show`] = true
        this[`searchParams${i + 1}`] = JSON.parse(localStorage.getItem(`searchParams${i + 1}`))
      } else {
        this[`page${i + 1}Show`] = false
      }
    }
  },
  methods: {
    downPdf() {
      const arr = []
      for (let i = 0; i < 3; i++) {
        if (localStorage.getItem(`page${i + 1}Show`) === 'true') {
          if (i === 0) {
            for (let a = 0; a < 4; a++) {
              arr.push(document.getElementById(`Page1Pdf${a + 1}`))
            }
          }
          if (i === 1) {
            if (this.searchParams2.groupBetweenCompareType === 101) {
              for (let a = 0; a < 3; a++) {
                arr.push(document.getElementById(`Page2Pdf${a + 1}`))
              }
            }
            if (this.searchParams2.groupBetweenCompareType === 103) {
              for (let a = 3; a < 5; a++) {
                if (a === 5) {
                  this.zones.map((b) => {
                    this.$refs[`Page2Pdf${a + 1}${b}`][0].getEle().map((v) => {
                      arr.push(v)
                    })
                  })
                } else {
                  this.$refs[`Page2Pdf${a + 1}`].getEle().map((v) => {
                    arr.push(v)
                  })
                }
              }
            }
          }
          console.info(localStorage.getItem(`page${i + 1}Show`), i)
          if (i === 2) {
            for (let a = 0; a < 3; a++) {
              arr.push(document.getElementById(`Page3Pdf${a + 1}`))
            }
          }
        }
      }
      console.info(arr)
      this.$nextTick(() => {
        setTimeout(() => {
          savePdfImgs(arr, '群体分析报告', () => {
          })
        }, 500)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.down-btn{
  height: 32px;
  line-height: 10px;
}
.pdf-all{
  padding: 30px;
  text-align: center;
}
.report-pdf{
  margin-bottom: 20px;
}
</style>
